import Vue from 'vue'
import Moment from 'moment'
import '../data'
import defaultUserAvatar from '@/assets/default/face.jpg';
import defaultCompanyLogo from '@/assets/default/company.png';
import defaultAvatarMen from '@/assets/default/men.jpg';
import defaultAvatarWomen from '@/assets/default/women.jpg';
import defaultSchoolIcon from '@/assets/default/school.png';
import defaultLogoIcon from '@/assets/default/logo.png';
import defaultYearReportAvatar from '@/assets/yearReport/defaultAvatar.png';
import defaultCustomerAvatar from '@/assets/default/customer.png';

Moment.locale('zh-cn');
//默认头像
const defaultAvatars = {
  user: defaultUserAvatar,
  company: defaultCompanyLogo,
  men: defaultAvatarMen,
  women: defaultAvatarWomen,
  school: defaultSchoolIcon,
  logoIcon: defaultLogoIcon,
  yearReport: defaultYearReportAvatar,
  customer: defaultCustomerAvatar
};

Vue.filter('avatar', (url, type = "user") => {
  return url || defaultAvatars[type];
});
//提现 - 反馈时长
Vue.filter('withdrawFeedbackTime', (input, defaultBlank = '3天') => {
  if (!input) {
    return defaultBlank;
  } else if (input > 0 && input < 9) {
    return input + "小时";
  } else if(input > 90){
    return '10天以上';
  } else {
    return Math.ceil(input / 9) + '天';
  }
});

//日期格式化 引用moment.js库
Vue.filter('date', (input, format = 'YYYY-MM-DD') => {
  if (input) {
    const m = Moment(input);
    return m.format(format);
  } else {
    return '';
  }
});
//订单状态
Vue.filter('allCandidateStatus', (v) => {
  return METADATA.allCandidateStatus[v];
});
//保证期
Vue.filter('guaranteeTime', (input) => {
  return input == null ? '无' : input === 0 ? '6个月或以下' : input == -1 ? '无' : input + '个月';
});
//做单指数
Vue.filter('gradeLevel', (input) => {
  let types = ['', '优', '良', '拥挤'];
  return types[input] ? types[input] : '';
});
//面试轮次
Vue.filter('interviewTimesFilter', (id) => {
  let _d = window.METADATA.interviewTimesObj;
  return _d[id] || '';
});
//面试方式
Vue.filter('interviewTypeFilter', (id) => {
  let _d = window.METADATA.interviewTypeObj;
  return _d[id] || '';
});
//职位问答回复筛选
Vue.filter('userType', (input) => {
  let types = ['', 'HR 回复', '猎头回复', '猎上回复'];
  return types[input] ? types[input] : '';
});
// 行业
Vue.filter('industry', (input)=>{
  if(!input)
    return
  if (!Array.isArray(input)) {
    input = (input + '').split(',');
  }
  let industry = METADATA.industry;
  let desc = [];
  input.forEach(item=>{
    if(industry[item]&&industry[item].displayName){
      desc.push(industry[item].displayName);
    }
  })
  return desc.join(',');
});
// exp: {{ 4112233.44678 | currency}} => 4,112,233.44 ; {{ 4112233.44678 | currency(3,'¥',',','.')}} => ¥4,112,233.446
Vue.filter('currency', (value, places, symbol, thousand, decimal) => {
  places = !isNaN(places = Math.abs(places)) ? places : 0;
  symbol = symbol !== undefined ? symbol : "";
  thousand = thousand || ",";
  decimal = decimal || ".";
  let negative = value < 0 ? "-" : "",
    i = parseInt(value = Math.abs(+value || 0).toFixed(places), 10) + "",
    j = (j = i.length) > 3 ? j % 3 : 0;
  return symbol + negative + (j ? i.substr(0, j) + thousand : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousand) + (places ? decimal + Math.abs(value - i).toFixed(places).slice(2) : "");
});
//薪资类型
Vue.filter('salaryType', v => {
  return v&&v==1 ? '税后' : '税前';
});
//性别
Vue.filter('gender', v => {
  return v == 1 ? '男' : v == 2 ? '女' : '';
});
//候选人薪资 -万
Vue.filter('tenThousand', (input, noNeed) => {
  const val = !isNaN(input) ? ((input % 10000 == 0 ? input / 10000 : ((input || 0) / 10000).toFixed(1))) : 0;
  return val + (noNeed ? '' : '万');
});
//年龄
Vue.filter('userAge', v => {
  if (!v)
    return '';
  if (v.split('.').length > 1) {
    v = v.split('.')[0] + '-' + v.split('.')[1];
  }
  if (v.split('-')[0].length != 4)
    return '';

  let currentYear = (new Date()).getFullYear();
  return currentYear - v.split('-')[0] > 0 ? currentYear - v.split('-')[0] : 0;
});
//学历
Vue.filter('degree', (item) => {
  let degreeType = {
    1: '本科',
    3: '硕士',
    4: '博士',
    5: '博士后',
    6: 'MBA',
    8: '大专',
    9: '大专以下'
  }
  return degreeType[item] ? degreeType[item] : '--'
});
//城市
Vue.filter('city', input => { // 30201
  if(!input)
    return "";
  let citys = window.METADATA.citys;
  let arr = (input+'').split(',');
  let desc = [];
  arr.forEach(item=>{
    if(citys[item]&&citys[item].name){
      desc.push(citys[item].name);
    }
  })
  return desc.join(',');
});
//求职状态
Vue.filter('applyJobStatus', v => {
  return METADATA.applyJobStatusMap[v] || "";
});
//处理日期
Vue.filter('formatMonthSelect', (time) => {
  if (!time) return '';

  if (time == '9999.12' || time == '9999-12') {
    return '至今';
  } else {
    if (time.split('.').length > 1) {
      let year = parseInt(time.split('.')[0]),
        month = parseInt(time.split('.')[1]);
      return year + '.' + (month < 10 ? '0' : '') + month;
    } else {
      let year = parseInt(time.split('-')[0]),
        month = parseInt(time.split('-')[1]);
      return year + '.' + (month < 10 ? '0' : '') + month;
    }

  }
});
Vue.filter('timeRange', (input) => {
  if (!input)
    return '';

  let syear, smonth, eyear, emonth; // review: 驼峰命名

  syear = input.startYear;
  eyear = input.endYear;
  smonth = input.startMonth;
  emonth = input.endMonth;

  if (input.endYear == 9999) {
    eyear = (new Date()).getFullYear();
    emonth = (new Date()).getMonth() + 1;
  }

  let year = eyear - syear;
  let month = emonth - smonth;

  if (month < 0) {
    year--;
    month = 12 - smonth + emonth;
  }

  if (year < 0) {
    return '';
  } else if (year === 0) {
    if (!month) {
      return '';
    } else {
      return month + '个月';
    }

  } else {
    if (month > 0) {
      return year + '年' + month + '个月';
    } else {
      return year + '年';
    }
  }
});
Vue.filter('dateAndRange', (item) => {
  const {
    startYear,
    startMonth,
    endYear,
    endMonth
  } = item;
  if (!startYear || !startMonth || !endYear || !endMonth) {
    return ''
  }
  const timeRange = Vue.filter('timeRange');
  return `${item.startYear}.${item.startMonth} - ${item.endYear==9999?'至今':`${item.endYear}.${item.endMonth}`}（${timeRange(item)}）`;
});
//口语能力 或 书写能力
Vue.filter('languageVerbal', (input) => {
  if (typeof input == 'number') {
    let str = {
      1: '一般',
      2: '良好',
      3: '熟练',
      4: '精通'
    }
    return str[input] || '';
  } else {
    return input;
  }
});


// 小数转百分数
Vue.filter('toPercent', (input, scale)=>{
  if(!input)
    return

  return Number(input*100).toFixed(scale || 0);
})
// 小数转百分数new
Vue.filter('toPercentNew', (input, scale)=>{
  if(!input)
    return 0;

  if(Number.isInteger(input*100)){
    return input*100;
  }else{
    return Number(input*100).toFixed(scale || 0);
  }
})
//面试流程
Vue.filter('numberDescFilter', (min, max, type) => {
  if (max == min) {
    if (min == -1) {
      return '不限';
    } else if (max == 0) {
      return '-';
    } else {
      return min + type;
    }
  } else {
    if (min == -1) {
      return max + type + '以下';
    } else if (max == -1) {
      return min + type + '以上';
    } else if (max == 0) {
      return '-';
    } else {
      return min + '-' + max + type;
    }
  }
});

Vue.filter('developStatus', (val) => {
  const developStatus = {
    1: '未融资',
    2: '天使轮',
    3: 'A轮',
    4: 'B轮',
    5: 'C轮',
    6: 'D轮及以上',
    7: '上市公司'
  };
  return developStatus[val] ? developStatus[val] : '---';
});

Vue.filter('companyScale', (val) => {
  const companyScale = [
    '1-49人',
    '50-99人',
    '100-499人',
    '500-999人',
    '1000-4999人',
    '5000-9999人',
    '10000+人'
  ];
  return companyScale[val] ? companyScale[val] : '其他';
});

Vue.filter('roughFriendlyDate', (time, format = 'YYYY-MM-DD') => {
  if (!time) return '';

  const cur = +new Date() - 0;
  let diff = time - cur;
  const reverted = diff > 0;
  diff = Math.abs(diff);
  if (diff < 3 * 60 * 1000) {
    return '刚刚';
  }
  if (diff < 60 * 60 * 1000) {
    return `${Math.floor(diff / 60 / 1000)}分钟${reverted ? '后' : '前'}`;
  }
  if (diff < 24 * 60 * 60 * 1000) {
    return `${Math.floor(diff / 60 / 60 / 1000)}小时${reverted ? '后' : '前'}`;
  }
  if (diff < 30 * 24 * 60 * 60 * 1000) {
    return `${Math.floor(diff / 24 / 60 / 60 / 1000)}天${reverted ? '后' : '前'}`;
  }
  const m = Moment(time);
  return m.format(format);
});

export default {}